module.exports = __webpack_public_path__ + "static/settings-1-076507b5fca38855fe38248cfcffc765.png";